import register from './register'
import home from './home'
import issued from './issued'
import searcher from './searcher'
import genericerror from './genericerror'
import summary from './summary'

export default {
  register,
  home,
  issued,
  searcher,
  genericerror,
  summary
}
